<template>
  <div>
    <horizontal-navbar @search="searchPatients"></horizontal-navbar>
    <breadcrumb-slot :items="items" :modal="false"></breadcrumb-slot>
    <div class="p-1 d-flex justify-content-between">
      <h2 class="text-dark">რისკ-ჯგუფის კლიენტები</h2>
    </div>

    <table-basic-patients v-if="risk_groups_meta"
                          :rows="risk_groups"
                          :columns="columns"
                          :accounts_meta="risk_groups_meta"
                          class-name="contacts-container"
                          paging="15"
                          @redirect="redirectToProfile"
                          @updateTable="getRiskGroups"/>
  </div>
</template>

<script>
import BreadcrumbSlot from "../components/breadcrumb/BreadcrumbSlot";
import TableBasicPatients from "../table/bs-table/TableBasicPatients";
import modulePatients from "../../store/patient/modulePatients"
import HorizontalNavbar from "../navbar/HorizontalNavbar";

export default {
  name: "RiskGroups",
  components: {HorizontalNavbar, TableBasicPatients, BreadcrumbSlot},
  data() {
    return {
      tableVisible: true,
      items: [
        {
          text: "რისკ-ჯგუფები",
          active: true
        }
      ],
      columns: [
        {
          key: "name",
          label: "სახელი",
          sortable: true
        },
        {
          key: "institutions",
          label: "დაწესებულება",
          sortable: true
        },
        {
          key: "risk_factors",
          label: "რისკ ფაქტორი",
          sortable: true,
        },
        {
          key: "medication",
          label: "მკურნალობა",
          sortable: true,
        },
        {
          key: "next",
          label: "შემდეგი მიდევნება",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
        },
      ],
    }
  },

  computed: {
    risk_groups() {
      return this.$store.state.patients.risk_groups
    },
    risk_groups_meta() {
      return this.$store.state.patients.risk_groups_meta
    },
  },

  created() {
    if (!modulePatients.isRegistered) {
      this.$store.registerModule("patients", modulePatients);
      modulePatients.isRegistered = true
    }
    this.getRiskGroups();
  },

  methods: {

    searchPatients(searchWord) {
      this.getRiskGroups({searchWord: searchWord});
    },

    redirectToProfile(value) {
      this.$router.push({name: "risk-group-profile", params: {id: value.id}})
    },

    getRiskGroups(payload = {}) {
      this.tableVisible = false;
      this.$store.dispatch("patients/getRiskGroups", payload).then(() => {
        this.tableVisible = true;
      }).catch((err) => {
      });
    }
  }
}
</script>

<style scoped>

</style>
